import { Route, Switch } from "react-router-dom";

import StoresLikeYoursPage from "@faire/prototype-playground/workspace/np/stores-like-yours";

export function NakulPathakRoutes() {
  return (
    <Switch>
      <Route path="/np/stores-like-yours" component={StoresLikeYoursPage} />
    </Switch>
  );
}

export const slug = "np";
